const compareVehiclesElement = document.getElementById("compare-vehicles");
const compareButtons = document.querySelectorAll(".compare-action");
const compareButton = compareVehiclesElement.querySelector(".btn-compare");
const cancelButton = compareVehiclesElement.querySelector(".btn-cancel");
let selectedVins = [];

/**
 * Toggles the selection of a VIN and updates the compare vehicles UI accordingly.
 *
 * @param {string} vin - The VIN to toggle the selection for.
 * @param {boolean} isChecked - Whether the VIN is being checked or unchecked.
 */
function toggleVinSelection(vin, isChecked) {
  if (isChecked) {
    selectedVins.push(vin);
  } else {
    selectedVins = selectedVins.filter((selectedVin) => selectedVin !== vin);
  }

  // If there are no selected VINs, the compare vehicles UI is hidden.
  compareVehiclesElement.classList.toggle(
    "is-hidden",
    selectedVins.length === 0
  );

  const uncheckedButtons = document.querySelectorAll(
    ".compare-action:not(.is-checked)"
  );

  // Disable buttons that are unchecked if there are already 3 selected VINs.
  uncheckedButtons.forEach((button) => {
    button.disabled =
      selectedVins.length > 2 && !button.classList.contains("is-checked");
  });

  // If there are less than 2 selected VINs, the compare buttons are disabled.
  compareButton.disabled = selectedVins.length < 2 || selectedVins.length > 3;
}

compareButtons.forEach((button) => {
  button.addEventListener("click", function (event) {
    event.stopPropagation();
    this.classList.toggle("is-checked");
    const parentDiv = this.closest(".card.card--car.p-0");
    const vin = parentDiv.getAttribute("value");
    toggleVinSelection(vin, this.classList.contains("is-checked"));
  });
});

// Redirect to the compare vehicles page when the compare button is clicked.
compareButton.addEventListener("click", function () {
  const vinsParam = encodeURIComponent(JSON.stringify(selectedVins));
  window.location.href = `https://www.bumper.com/tools/compare-cars/?vins=${vinsParam}`;
});

// Reset the compare vehicles UI when the cancel button is clicked.
cancelButton.addEventListener("click", function () {
  selectedVins = [];
  const allButtons = document.querySelectorAll(".compare-action");
  allButtons.forEach((button) => {
    button.classList.remove("is-checked");
    button.disabled = false;
  });
  compareVehiclesElement.classList.add("is-hidden");
});
